export enum TrafficLabelId {
  GENERAL = 'general',
  FACEBOOK = 'facebook',
  TWITTER = 'twitter',
  WHATSAPP = 'whatsapp',
  VPN_BRANDVNO = 'vpn-brandvno',
}
